import { getOccTransport } from "~/common/api/occTransport";
import { getCsrfValue } from "~/common/utils/ApiHelper";

import type { OnboardingFormValues } from "../components/Onboarding/useOnboardingForm";
import { AFFILIATE_FORM_KEY } from "~/domains/affiliate/types/form";

interface CompleteAccountPostData extends OnboardingFormValues {
  passwordToken: string;
  affiliateId?: string;
}

export interface CompleteRegistrationResponse {
  globalErrors: string[];
  validationResults: {
    password?: string[];
  };
}

export const putCompleteRegistration = async (data: CompleteAccountPostData): Promise<CompleteRegistrationResponse> => {
  const { put, url } = getOccTransport();
  const isPreferredSalesPartner = !!data[AFFILIATE_FORM_KEY]?.id;
  const response = await put(
    url("/registered-user/update"),
    {
      body: JSON.stringify({
        email: data.email,
        firstName: data.firstName,
        lastName: data.lastName,
        password: data.password,
        checkPassword: data.confirmPassword,
        company: data.company,
        line1: data.address,
        line2: data.addressAdditional,
        zipCode: data.zipCode,
        city: data.city,
        country: data.country,
        phone: data.phone,
        salutationCode: data.salutation,
        titleCode: data.title,
        industrySector: data.industrySector,
        jobTitle: data.jobTitle,
        functionalArea: data.functionalArea,
        token: data.passwordToken,
        isPreferredSalesPartner: isPreferredSalesPartner,
        affiliateId: isPreferredSalesPartner ? data[AFFILIATE_FORM_KEY]?.id ?? undefined : data.affiliateId,
        subsidiary: isPreferredSalesPartner ? data[AFFILIATE_FORM_KEY]?.subsidiary ?? undefined : undefined,
        customerCategoryCode: data.customerCategory,
        knowledgeAreaCode: data.knowledgeArea,
        languageIsoCode: data.language,
        vatNumber: data.vat,
      }),
      credentials: "same-origin", // include, omit
      mode: "cors", // no-cors, same-origin
      referrer: "no-referrer", // client
      headers: {
        "content-type": "application/json",
        CSRFToken: getCsrfValue(),
      },
    },
    { accountContext: "omit" },
  );

  if (!response.ok) {
    const message = `Error status: ${response.status}, please try again`;
    if (typeof window.alert === "function") {
      window.alert(message);
    }
    throw new Error(message);
  }

  return response.json() as Promise<CompleteRegistrationResponse>;
};
